import { useEffect, useRef } from 'react';

import { type ArbitrationSocketMessage, openArbitrationSocket } from '../utils/arbitrationSocket';

/**
 * Résout l'URL du WebSocket d'arbitrage. Identique à la logique qui était
 * dupliquée dans `DealsList` et `AgencyDealsList`.
 */
export const resolveArbitrationWsUrl = (): string => {
  const isLocalBackend = process.env.NODE_ENV === 'development' || process.env.FORCE_LOCAL_WS;
  if (isLocalBackend) {
    return `ws://localhost:${import.meta.env.VITE_BACKEND_PORT || '3001'}`;
  }

  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}/ws`;
};

/**
 * Branche le cycle de vie de `openArbitrationSocket` sur celui du composant.
 *
 * `onMessage` est lu à travers une ref : le handler peut être une closure
 * recréée à chaque rendu sans provoquer de reconnexion, et il voit toujours le
 * dernier état du composant (l'ancien code capturait celui du montage).
 */
export const useArbitrationSocket = (
  enabled: boolean,
  onMessage: (message: ArbitrationSocketMessage) => void,
): void => {
  const onMessageRef = useRef(onMessage);

  useEffect(() => {
    onMessageRef.current = onMessage;
  });

  useEffect(() => {
    if (!enabled) return;

    return openArbitrationSocket({
      url: resolveArbitrationWsUrl(),
      onMessage: (message) => onMessageRef.current(message),
    });
  }, [enabled]);
};
